module.exports = __webpack_public_path__ + "media/images/new_article_popup_icon-6b9db0c8b91784da9a1a9ffd6d53896d.png";